import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_MANY,
  EMPTY_TO_ONE,
  linkageFromResource,
} from '@opallabs/json-api'
import { blockResourceFactory } from './block'
import { userResourceFactory } from './user'
import { workspaceResourceFactory } from './workspace'

type ViewResourceV3 = OpalApiComponent<'V3', 'view'>

export const viewResourceFactory: Factory<ViewResourceV3> =
  Factory.define<ViewResourceV3>(({ sequence }) => {
    const defaultCreator = linkageFromResource(userResourceFactory.build())

    return {
      id: uuidV4(),
      type: 'view',
      attributes: {
        created_at: new Date().toISOString(),
        default_timescale: 'month',
        description: null,
        end_at: new Date().toISOString(),
        kind: 'plan',
        start_at: new Date().toISOString(),
        start_month_index: 0,
        start_weekday_index: 0,
        show_smart_swimlane_datasource: true,
        swimlane_title_column_width: 200,
        title: `Mock Plan ${sequence}`,
        updated_at: new Date().toISOString(),
      },
      relationships: {
        blocks: EMPTY_TO_MANY,
        categories: EMPTY_TO_MANY,
        category_type: EMPTY_TO_ONE,
        colors: EMPTY_TO_MANY,
        creator: defaultCreator,
        key_dates: EMPTY_TO_MANY,
        owner: defaultCreator,
        parent_block: linkageFromResource(blockResourceFactory.build()),
        workspace: linkageFromResource(workspaceResourceFactory.build()),
      },
    } satisfies ViewResourceV3
  })
